import { ModelBase } from 'store/model-base';

export class CmsStatementList extends ModelBase {
    public static storeName: string = 'cmsStatementList';

    public breadcrumbLabel: string;
    public header: string;
    public billingCycle: string;
    public viewMoreButton: string;
    public caretIcon: CmsMediaImage;
    public grayArrowBtn: CmsMediaImage;
    public subHeader: string;
    public description: string;
    public title: string;
    public upcomingCharges: string;
    public currentStatement: string;
    public pdfCta: string;
    public downloadIcon: Image;
    public errorIcon: CmsMediaImage;
    public errorText: string;
    public xaChatBanner: CmsStatementXABanner;
    public nextBillEstimate: string;
    public billHistoryTitle: string;
    public billPdfCta: string;
}
